import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const Dota2 = () => {
  return (
    <SportsLayoutComp name={'Dota 2'}/>
  )
}

export default Dota2